export default "__VITE_ASSET__DZ95OMUb__"